<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-network-status-banner></app-network-status-banner>

  <!-- Global debug overlay -->
  <app-debug-panel></app-debug-panel>
  <app-terms-blocker *ngIf="(blockingRequired$ | async)"></app-terms-blocker>
  <ng-container *ngIf="(syncUi.ui$ | async) as s">
    <div class="sync-bar" 
      *ngIf="s.show" 
      [class.is-error]="!!s.error"
      [class.is-mini]="!s.error && !s.done"
    >
      <ion-spinner name="crescent" *ngIf="!s.done && !s.error"></ion-spinner>

      <div class="sync-bar__text">
        <div class="sync-bar__title">
          {{ s.error ? 'Sync failed' : (s.done ? 'Sync complete' : 'Syncing…') }}
        </div>
        <div class="sync-bar__msg" *ngIf="!(!s.error && !s.done)">{{ s.label }}</div>
      </div>

      <div class="sync-bar__right">
        <div class="sync-bar__pct" *ngIf="!s.error">{{ s.pct }}%</div>
        <ion-button fill="clear" size="small" (click)="syncUi.hide()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </div>

      <ion-progress-bar
        [value]="s.pct / 100"
      ></ion-progress-bar>
    </div>
  </ng-container>
</ion-app>